import React, { useState, useCallback, useEffect } from 'react';
import { propOr, pathOr, isEmpty, compose, find, prop, values } from 'ramda';
import { Mutation } from 'react-apollo';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { CREATE_JOB, UPDATE_JOB } from '../apollo/mutation';
import { GET_JOB, GET_CURRENT_SUBSCRIPTION } from '../apollo/queries';
import {
  Form,
  Page,
  Card,
  Button,
  Badge,
  FormLayout,
  TextField,
  AppProvider,
  Toast,
  Frame,
  Select,
  Modal,
  TextContainer,
  Spinner,
  Checkbox,
  Layout,
  InlineError,
} from '@shopify/polaris';
import moment from 'moment';
import { TitleBar } from '@shopify/app-bridge-react';
import { Editor } from '@tinymce/tinymce-react';

import { onSubmitFailed } from '../../utils/errors';

const categories = [
  { label: 'Select Category', value: '' },
  { label: 'Accounting', value: 'accounting' },
  { label: 'Administrative & Office', value: 'administrative and office' },
  { label: 'Cleaning & Facilities', value: 'cleaning and facilities' },
  { label: 'Customer Service', value: 'customer service' },
  { label: 'Design', value: 'design' },
  { label: 'Education', value: 'education' },
  { label: 'Engineering', value: 'engineering' },
  { label: 'Healthcare', value: 'healthcare' },
  { label: 'Human Resources', value: 'human resources' },
  {
    label: 'Installation, Maintenance & Repair',
    value: 'installation, mantenance and repair',
  },
  { label: 'Legal', value: 'legal' },
  { label: 'Management', value: 'managment' },
  { label: 'Marketing', value: 'marketing' },
  { label: 'Merchandising', value: 'merchandising' },
  { label: 'Personal Care Services', value: 'personal care services' },
  { label: 'Hospitality', value: 'hospitality' },
  { label: 'Retail', value: 'retail' },
  { label: 'Sales', value: 'sales' },
  {
    label: 'Social Services & Nonprofit',
    value: 'social services and nonprofit',
  },
  { label: 'Fitness', value: 'fitness' },
  { label: 'Logistics', value: 'logistics' },
  { label: 'Technology', value: 'technology' },
  { label: 'Production', value: 'production' },
  { label: 'Manufacturing', value: 'manufacturing' },
  { label: 'Food Production', value: 'food production' },
  { label: 'eCommerce', value: 'eCommerce' },
  { label: 'Finance', value: 'finance' },
  { label: 'NoCode', value: 'noCode' },
  { label: 'Operations', value: 'operations' },
  { label: 'Public Relations', value: 'public relations' },
];

const currencies = [
  { label: 'US Dollar (USD)', value: 'USD' },
  { label: 'Euro (EUR)', value: 'EUR' },
  { label: 'British Pound (GBP)', value: 'GBP' },
  { label: 'Canadian Dollar (CAD)', value: 'CAD' },
  { label: 'Australian Dollar (AUD)', value: 'AUD' },
  { label: 'South African Rand (ZAR)', value: 'ZAR' },
];

const compensationTypes = [
  { label: 'Hourly', value: 'HOUR' },
  { label: 'Daily', value: 'DAY' },
  { label: 'Monthly', value: 'MONTH' },
  { label: 'Annually', value: 'YEAR' },
];

const employments = ['Full-Time', 'Part-Time', 'Contractor', 'Temporary', 'Internship', 'Other'];

const JobSetupTemplate = (props) => {
  const node = document.getElementsByClassName('shop_container');
  const dataProps = JSON.parse(node[0].getAttribute('data-react-props'));
  const [isLoading, setLoading] = useState(false);
  const [active, setActive] = useState(false);
  const [checked, setChecked] = useState(false);
  const [archiveModal, setArchiveModal] = useState(false);
  const [toastStatus, setToastStatus] = useState({ status: false, message: '' });
  const [formErrors, setFormErrors] = useState({
    title: false,
    category: false,
    department: false,
    employmentType: false,
    description: false,
  });

  const [updateJob] = useMutation(UPDATE_JOB);
  const min = 0;
  const max = 1000000;

  const handleChange = useCallback((newChecked) => setChecked(newChecked), []);
  const toggleArchiveModal = () => setArchiveModal(!archiveModal);
  let { history } = props;
  const [errors, setErrors] = useState('');
  const [form, setState] = useState({
    title: '',
    description: '',
    department: '',
    employmentType: 'Full-Time',
    category: 'marketing',
    compensationType: 'Hourly',
    currency: 'US Dollar (USD)',
    minCompensationRange: '0',
    maxCompensationRange: '0',
    plusComission: false,
  });

  const { data: dataR, loading: landingR, refetch: refetchR } = useQuery(GET_JOB, {
    variables: { shopifyToken: dataProps.shop.shopify_token, jobId: props.match.params.id },
  });
  const { loading: loadingT, data: subscriptionData, refetch: refetchT } = useQuery(GET_CURRENT_SUBSCRIPTION, {
    variables: { shopifyToken: dataProps.shop.shopify_token },
  });

  const shop = propOr({}, 'shop')(subscriptionData);
  const job = propOr({}, 'job')(dataR);
  const careerPortal = shop?.careerPortal || {};
  const departments = careerPortal?.departments || [];

  if (props.match.params.id) {
    useEffect(() => {
      if (job.title) {
        setState({
          ...form,
          description: job.description,
          category: job.category,
          department: job.department?.id,
          employmentType: job.employmentType,
          title: job.title,
          compensationType: job.compensationType,
          currency: job.currency,
          minCompensationRange: job.minCompensationRange ? job.minCompensationRange.toString() : '0',
          maxCompensationRange: job.maxCompensationRange ? job.maxCompensationRange.toString() : '0',
          plusComission: job.plusComission,
        });
      }
      refetchR();
    }, [job]);
  }

  // if()

  const updateField = (name) => (value) => {
    setFormErrors({ ...formErrors, [name]: false });

    setState({
      ...form,
      [name]: value,
    });
  };

  const handleEditorChange = (e) => {
    setState({
      ...form,
      description: e.target.getContent(),
    });
  };

  const handleFormSubmit = async (props) => {
    let { createJob, duplicate = false } = props;

    setLoading(true);

    const response = await createJob({
      variables: {
        title: duplicate ? `Copy of ${form.title}` : form.title,
        description: form.description,
        employmentType: form.employmentType,
        department: form.department,
        category: form.category,
        shopifyToken: dataProps.shop.shopify_token,
        status: 'open',
        compensationType: form.compensationType,
        currency: form.currency,
        minCompensationRange: form.minCompensationRange,
        maxCompensationRange: form.maxCompensationRange,
        plusComission: form.plusComission,
        isTemplate: true,
      },
    });

    const errors = pathOr([], ['data', 'createJob', 'errors'])(response);
    const emptyErrors = isEmpty(errors);
    setLoading(false);
    if (emptyErrors) {
      const newJob = pathOr({}, ['data', 'createJob', 'job'])(response);
      const { id: jobId = '' } = { ...newJob };
      refetchR();
      history.push(`/set-job-template/${jobId}`);
      setToastStatus({
        status: true,
        message: `The job description template was ${duplicate ? 'duplicated' : 'created'} successfully.`,
      });
    } else {
      setToastStatus({ status: true, message: 'There is an error with the server' });
    }
  };

  const updateJobForm = () => {
    const updatedErrors = {
      title: compose(isEmpty, prop('title'))(form),
      category: compose(isEmpty, prop('category'))(form),
      department: compose(isEmpty, prop('department'))(form),
      employmentType: compose(isEmpty, prop('employmentType'))(form),
      streetAddress: compose(isEmpty, prop('streetAddress'))(form),
      city: compose(isEmpty, prop('city'))(form),
      postalCode: compose(isEmpty, prop('postalCode'))(form),
      country: compose(isEmpty, prop('country'))(form),
      state: compose(isEmpty, prop('state'))(form),
      description: compose(isEmpty, prop('description'))(form),
    };

    setFormErrors(updatedErrors);

    if (
      compose(
        find((item) => item),
        values
      )(updatedErrors)
    ) {
      setTimeout(() => {
        onSubmitFailed();
      }, 10);
    } else {
      setLoading(true);

      const response = updateJob({
        variables: {
          jobId: props.match.params.id,
          title: form.title,
          description: form.description,
          employmentType: form.employmentType,
          category: form.category,
          department: form.department,
          shopifyToken: dataProps.shop.shopify_token,
          compensationType: form.compensationType,
          currency: form.currency,
          minCompensationRange: form.minCompensationRange,
          maxCompensationRange: form.maxCompensationRange,
          plusComission: form.plusComission,
        },
      });

      const errors = pathOr([], ['data', 'updateJob', 'errors'])(response);
      const emptyErrors = isEmpty(errors);
      setLoading(false);
      if (emptyErrors) {
        setToastStatus({ status: true, message: 'The job description was updated successfully.' });
        refetchR();
      } else {
        setToastStatus({ status: true, message: 'There is an error with the server' });
      }
    }
  };

  const updateArchivedProp = (archived) => {
    setLoading(true);
    setArchiveModal(false);
    const response = updateJob({
      variables: {
        jobId: props.match.params.id,
        title: job.title,
        archived,
        description: job.description,
        employmentType: job.employmentType,
        category: job.category,
        department: job.department?.id,
        shopifyToken: dataProps.shop.shopify_token,
        compensationType: job.compensationType,
        currency: job.currency,
        // hack: we should really be passing ints here
        minCompensationRange: job.minCompensationRange?.toString(),
        maxCompensationRange: job.maxCompensationRange?.toString(),
        plusComission: job.plusComission,
      },
    });

    const errors = pathOr([], ['data', 'updateJob', 'errors'])(response);
    const emptyErrors = isEmpty(errors);
    if (emptyErrors) {
      setTimeout(() => {
        refetchR();
        history.push('/settings/templates/job-descriptions');
      }, 500);
    }
  };

  const renderButton = isLoading ? (
    <TextContainer>
      <Spinner accessibilityLabel='Loading form field' size='large' color='teal' />

      <p> Publishing your page </p>
    </TextContainer>
  ) : props.match.params.id ? (
    <Button primary={true} onClick={() => updateJobForm()} size='large'>
      Update
    </Button>
  ) : (
    <Button primary={true} submit={true} size='large'>
      Save
    </Button>
  );

  const onSubmit = (action) => {
    const updatedErrors = {
      title: compose(isEmpty, prop('title'))(form),
      category: compose(isEmpty, prop('category'))(form),
      department: compose(isEmpty, prop('department'))(form),
      employmentType: compose(isEmpty, prop('employmentType'))(form),
      streetAddress: compose(isEmpty, prop('streetAddress'))(form),
      city: compose(isEmpty, prop('city'))(form),
      department: compose(isEmpty, prop('department'))(form),
      postalCode: compose(isEmpty, prop('postalCode'))(form),
      country: compose(isEmpty, prop('country'))(form),
      state: compose(isEmpty, prop('state'))(form),
      description: compose(isEmpty, prop('description'))(form),
    };

    setFormErrors(updatedErrors);

    if (
      compose(
        find((item) => item),
        values
      )(updatedErrors)
    ) {
      setTimeout(() => {
        onSubmitFailed();
      }, 10);
    } else {
      handleFormSubmit(action);
    }
  };

  return (
    <Mutation mutation={CREATE_JOB}>
      {(createJob) => (
        <AppProvider>
          <Frame>
            {toastStatus.status && (
              <Toast content={toastStatus.message} onDismiss={() => setToastStatus({ status: false, message: '' })} />
            )}
              <TitleBar title='Job Templates' breadcrumbs={[{ content: 'Settings', onAction: () => { history.push("/settings"); } }]} />
            <Page
            breadcrumbs={[{ content: 'Job descriptions', onAction: () => { history.push('/settings/templates/job-descriptions'); } }]}
              title='Job Description Template'
              titleMetadata={
                props.match.params.id ? (
                  <Badge status={!job?.archived ? 'success' : 'default'}>
                    <span className={'capitalize'}>{job?.archived ? 'Archived' : 'Active'}</span>
                  </Badge>
                ) : null
              }
              subtitle={props.match.params.id ? `Updated ${moment(job?.updatedAt).format('MMMM D, YYYY')}` : ''}
              primaryAction={{
                content: props.match.params.id ? 'Update' : 'Save',
                onAction: props.match.params.id ? () => updateJobForm() : () => onSubmit({ createJob }),
              }}
              secondaryActions={
                props.match.params.id
                  ? [{ content: 'Duplicate', onAction: () => handleFormSubmit({ createJob, duplicate: true }) }]
                  : undefined
              }>
              <Form onSubmit={() => onSubmit({ createJob })}>
                <hr className='hr' />
                <br />
                <Layout>
                  <Layout.AnnotatedSection
                    title='Job details'
                    description='Details can be used to categorize the job and make jobs more discoverable on job boards.'>
                    <Card sectioned>
                      <FormLayout>
                        <div>
                          <TextField id='title' label='Title' value={form.title} name='title' onChange={updateField('title')} />
                          {formErrors.title && <InlineError message='Title is required' fieldID='title' />}
                        </div>
                        <FormLayout.Group>
                          <div>
                            <Select
                              id='department'
                              label='Department'
                              options={departments.map(({ id: value, headingText: label }) => ({ value, label }))}
                              onChange={updateField('department')}
                              value={form.department}
                              placeholder={'Select ...'}
                            />
                            {formErrors.department && <InlineError message='Department is required' fieldID='department' />}
                          </div>
                          <div>
                            <Select
                              id='category'
                              label='Category'
                              options={categories}
                              onChange={updateField('category')}
                              value={form.category}
                            />
                            {formErrors.category && <InlineError message='Category is required' fieldID='category' />}
                          </div>
                          <div>
                            <Select
                              id='employmentType'
                              label='Employment type'
                              options={employments}
                              onChange={updateField('employmentType')}
                              value={form.employmentType}
                            />
                            {formErrors.employmentType && (
                              <InlineError message='Employment type is required' fieldID='employmentType' />
                            )}
                          </div>
                        </FormLayout.Group>
                      </FormLayout>
                    </Card>
                  </Layout.AnnotatedSection>
                </Layout>
                <br />
                <hr className='hr' />
                <br />
                <Layout>
                  <Layout.AnnotatedSection
                    title='Compensation (optional)'
                    description='Job postings that list compensation information receive 38% more applicants.'>
                    <Card sectioned>
                      <FormLayout>
                        <FormLayout.Group>
                          <Select
                            id='currency'
                            label='Currency'
                            options={currencies}
                            onChange={updateField('currency')}
                            value={form.currency}
                          />
                          <span />
                        </FormLayout.Group>
                        <FormLayout.Group>
                          <Select
                            id='compensationType'
                            label='Compensation Type'
                            options={compensationTypes}
                            onChange={updateField('compensationType')}
                            value={form.compensationType}
                          />
                          <span />
                        </FormLayout.Group>
                        <FormLayout.Group>
                          <TextField
                            id='minCompensationRange'
                            value={form.minCompensationRange}
                            label='Minimum'
                            name='minCompensationRange'
                            type='number'
                            onChange={updateField('minCompensationRange')}
                          />
                          <TextField
                            id='maxCompensationRange'
                            value={form.maxCompensationRange}
                            name='maxCompensationRange'
                            label='Maximum'
                            type='number'
                            min={min}
                            max={max}
                            onChange={updateField('maxCompensationRange')}
                          />
                        </FormLayout.Group>
                        <Checkbox
                          name='plusComission'
                          id='plusComission'
                          label='Plus comission'
                          checked={form.plusComission}
                          onChange={updateField('plusComission')}
                        />
                        <FormLayout>
                          <p
                            className='Polaris-Layout__AnnotationDescription'
                            style={{ paddingLeft: '25px', marginBottom: '15px' }}>
                            Employees in this role will be able to receive a commission in addition to their base compensation.
                          </p>
                        </FormLayout>
                      </FormLayout>
                    </Card>
                  </Layout.AnnotatedSection>
                </Layout>
                <br />
                <hr className='hr' />
                <br />
                <Layout>
                  <Layout.AnnotatedSection
                    title='Job Description'
                    description="Summarize the job's essential responsibilities, activities, qualifications and skills to attract qualified candidates.">
                    <Card sectioned>
                      <FormLayout>
                        <div>
                          <Editor
                            initialValue={form.description || ''}
                            value={form.description}
                            init={{
                              height: 510,
                              menubar: false,
                              plugins: ['advlist autolink lists link', 'code fullscreen', 'wordcount', 'paste'],
                              toolbar:
                                'undo redo | formatselect | fontselect | fontsizeselect | bold italic forecolor | \
                        alignleft aligncenter alignright alignjustify | \
                        bullist numlist outdent indent | removeformat | help',
                              paste_as_text: true,
                              paste_block_drop: false,
                            }}
                            id='description'
                            name='description'
                            apiKey='czdl8uo4qtlzlp7ozdpws89rify9vokuyuvw21w1jr8n394z'
                            onChange={(e) => handleEditorChange(e)}
                          />
                          {formErrors.description && <InlineError message='Description is required' fieldID='description' />}
                        </div>
                      </FormLayout>
                    </Card>
                  </Layout.AnnotatedSection>
                </Layout>
                <br />
                <hr className='hr' />
                <br />
                <div className='career-portal__form-buttons'>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ marginRight: '10px' }}>
                      <Button onClick={() => history.push('/settings/templates/job-descriptions')} size='large'>
                        Cancel
                      </Button>
                    </div>
                    {!!props.match.params.id && (
                      <Button destructive={!job.archived} outline onClick={toggleArchiveModal} size='large'>
                        {!job.archived ? 'Archive' : 'Unarchive'} template
                      </Button>
                    )}
                  </div>
                  {renderButton}
                </div>
              </Form>
            </Page>
            <Modal
              open={archiveModal}
              onClose={toggleArchiveModal}
              title={`${!job.archived ? 'Archive' : 'Unarchive'} job description template`}
              primaryAction={{
                content: `Yes, ${job.archived ? 'un' : ''}archive`,
                onAction: () => updateArchivedProp(!job.archived),
              }}
              secondaryActions={[
                {
                  content: 'Cancel',
                  onAction: toggleArchiveModal,
                },
              ]}
              loading={false}>
              <Modal.Section>
                <p>
                  {`${!job.archived ? 'Archiving' : 'Unarchiving'} this job description template will ${
                    !job.archived ? 'hide' : 'show'
                  } it from your job description templates list page and the job template dropdown on job setup. You'll find it using the status filter in your job description template list.`}
                </p>
              </Modal.Section>
            </Modal>
          </Frame>
        </AppProvider>
      )}
    </Mutation>
  );
};

export default JobSetupTemplate;
